import request from "@/utils/request";

// 已采购明细列表
export function getPurchaseReportList(params) {
	return request({
		url:'/report/purchase/trace/list',
		method:'GET',
		params:params
	})
}

// 已采购明细列表
export function getTotalSkuList(data) {
	return request({
		url:'/scm/deliverOrder/detail/list',
		method:'POST',
		data
	})
}

// 已采购明细数据汇总
export function getTotalInfo(data) {
	return request({
		url:'/report/purchase/total',
		method:'POST',
		data
	})
}

// 已采购明细数据导出
export function purchasedExport(data) {
	request({
		url:'/scm/deliverOrder/detail/export',
		method:'POST',
		data,
		responseType: 'blob'
	})
}

// 已入库明细列表
export function getStockedSkuList(data) {
	return request({
		url:'/wms/stockIn/detail/list',
		method:'POST',
		data
	})
}

// 已采购明细数据导出
export function stockedExport(data) {
	request({
		url:'/wms/stockIn/detail/export',
		method:'POST',
		data,
		responseType: 'blob'
	})
}

// 已入库sku明细列表汇总
export function stockedTotal(data) {
	return request({
		url:'/report/stockIn/total',
		method:'POST',
		data
	})
}

// 未入库sku明细列表
export function unStockList(data) {
	return request({
		url:'/scm/deliverOrder/notStockIn/list',
		method:'POST',
		data
	})
}

// 未入库明细数据导出
export function unStockExport(data) {
	request({
		url: '/scm/deliverOrder/notStockIn/export',
		method:'POST',
		data,
		responseType: 'blob'
	})
}



// WEBPACK FOOTER //
// ./src/api/scm/purchase-report.js